<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索订单号,联系人,手机" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="商品">
              <a-select
                showSearch
                optionFilterProp="children"
                v-model="queryParam.goods_id"
                placeholder="选择商品"
                allowClear
              >
                <a-select-option
                  :key="option.id"
                  v-for="option in goodsOptions"
                  :value="option.id"
                >{{option.title}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择" allowClear>
                <a-select-option value="1">待付款</a-select-option>
                <a-select-option value="2">待发货/确认</a-select-option>
                <a-select-option value="3">待签收/使用</a-select-option>
                <a-select-option value="4">已完成</a-select-option>
                <a-select-option value="5">售后中</a-select-option>
                <a-select-option value="6">已关闭</a-select-option>
                <a-select-option value="2.1">待成团</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
           <a-col :md="6" :sm="24">
              <a-form-item label="销售">
                <user-picker
                        style="widt:100%; margin-right: 10px; "
                        :formData="queryParam"
                        field="sale_user_id"
                />
              </a-form-item>
            </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="下单日期">
                <a-range-picker
                  v-model="time_range_moment"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :showTime="{
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="合伙人">
                <user-picker
                        style="widt:100%; margin-right: 10px; "
                        :formData="queryParam"
                        field="partner_id"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
            <a-form-item label="所属地区">
              <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
              />
            </a-form-item>
          </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="分销员">
                <user-picker
                        style="widt:100%; margin-right: 10px; "
                        :formData="queryParam"
                        field="seller_user_id"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="团长">
                <user-picker
                        style="widt:100%; margin-right: 10px; "
                        :formData="queryParam"
                        field="team_seller_id"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="基地">
                <base-picker
                        style="widt:100%; margin-right: 10px; "
                        :formData="queryParam"
                        field="base_id"
                />
              </a-form-item>
            </a-col>
            <!--<a-col :md="6" :sm="24">-->
              <!--<a-form-item label="门店">-->
                <!--<shop-picker-->
                        <!--style="widt:100%; margin-right: 10px; "-->
                        <!--:formData="shopFormData"-->
                        <!--field="user_id"-->
                <!--/>-->
              <!--</a-form-item>-->
            <!--</a-col>-->

            <a-col :md="6" :sm="24">
              <a-form-item label="星级">
                <a-select v-model="queryParam.star" placeholder="请选择" allowClear>
                  <a-select-option value="-1">0星</a-select-option>
                  <a-select-option value="1">一星</a-select-option>
                  <a-select-option value="2">二星</a-select-option>
                  <a-select-option value="3">三星</a-select-option>
                  <a-select-option value="4">四星</a-select-option>
                  <a-select-option value="5">五星</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button @click="download('base')" style="margin-left: 8px">
        商品订单下载
        <a-icon type="download" />
      </a-button> 

      <a-button @click="download2('base')" style="margin-left: 8px">
        商品订单汇总表下载
        <a-icon type="download" />
      </a-button>


      <a-button @click="download3(1)" style="margin-left: 8px">
        省级奖励汇总表
        <a-icon type="download" />
      </a-button>
      <a-button @click="download3(2)" style="margin-left: 8px">
        市级奖励汇总表
        <a-icon type="download" />
      </a-button>
      <a-button @click="download4(3)" style="margin-left: 8px">
        合伙人奖励汇总表
        <a-icon type="download" />
      </a-button>

      <a-upload
        name="file"
        accept=".csv"
        action
        :before-upload="beforeUpload"
        style="margin-left: 8px"
      >
        <a-button>
          批量发货
          <a-icon type="upload" />
        </a-button>
      </a-upload>
      <a-popconfirm
        v-if="selectedRowKeys.length > 0"
        okText="确定"
        cancelText="取消"
        @confirm="setAllStar"
      >
        <span slot="icon" />
        <template slot="title">
          <a-rate style="font-size: 16px;" v-model="setAllStarValue" />
        </template>
        <a-button style="margin:8px  0 0 8px">
          批量标星
          <a-icon type="star" />
        </a-button>
      </a-popconfirm>
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">-->

      <!--<a-menu slot="overlay">-->
      <!--<a-menu-item  key="1"> -->
      <!--</a-menu-item>-->
      <!--<a-menu-item @click="setAllStatus(2)" key="2"><a-icon type="download" />下架</a-menu-item>-->
      <!--</a-menu>-->
      <!--<a-button style="margin-left: 8px">-->
      <!--批量操作 <a-icon type="down" />-->
      <!--</a-button>-->
      <!--</a-dropdown>-->
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :pageSize="10"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="goods" slot-scope="text,record">
        <div
          style="margin-bottom: 10px;padding-bottom: 10px; border-bottom: 1px solid #eee"
        >订单号 {{record.code}} &nbsp;&nbsp;
         <span style="color:red" v-if="record.gift_card">礼品券号:{{record.gift_card}}</span>
         <span  v-if="record.delivery_type==1"><a-tag color="#2db7f5">货到付款</a-tag></span>
         <a-tag v-if="record.company_name" color="#f50">
            单位:{{record.company_name}}
          </a-tag>
         </div>
        <div
          v-for="goods in record.items" :key="goods.id"
          style="margin-bottom: 10px ; padding-bottom: 10px; border-bottom: 1px solid #eee"
        >
          <img style="width: 38px ; height: 38px; float: left" :src="goods.pic_url" />
          <div style="margin-left: 10px; float: left; width: calc(100% - 60px)">
            {{goods.title}}
            <br />
            <span style="color: #999">{{goods.sku.sku_formart}}</span>
            x {{goods.count}} <br/>
             <span style="color: #999">退货</span> x{{goods.refund_count}}
            <br />
          </div>
          <div class="cf"></div>
        </div>
        <div>
          <a-alert
            style="margin-top:10px; " 
            :message="'用户名:'+record.user_name"
            type="success"
          /> 
          <a-alert
            style="margin-top:10px; "
            v-if="record.buyer_note"
            :message="'客户备注:'+record.buyer_note"
            type="success"
          />
          <a-alert
            style="margin-top:10px; "
            v-if="record.business_note"
            :message="'商家备注:'+record.business_note"
            type="warning"
          />
          
          <a-badge :status="record.status_data.class" :text="record.status_data.name" />

          <a-rate
            style="font-size: 16px; float: right;"
            @change="starChange(record)"
            v-model="record.star"
          />
          <div class="cf"></div>
        </div>
      </span>
      <span slot="buyer" slot-scope="text,record">
        <template>
          
          
          <div>
            {{record.address.name}}
            <br />
            {{record.address.phone}}
            <br />
            <span v-if="record.type=='base'">{{record.address.address}}</span>
          </div>
        </template>
      </span>
      <span slot="price" slot-scope="text,record">
        <template>
          <div>
            应付:<span class="hightlight">{{record.pay_price|price}}</span>元
            <br />
            已付:<span class="hightlight">{{record.payed_price|price}}</span>元
            <br />
            未付:<span class="hightlight">{{record.not_pay_price|price}}</span>元
            <br />
            下单 {{record.create_time|timeFormat}}
            <br />
            付款 <span v-if="record.pay_type=='offline'">{{record.offline_pay_time}}</span> 
                <span v-else>{{record.pay_time|timeFormat}}</span>
          </div>
        </template>
      </span>
      <span slot="sale_price" slot-scope="text,record">
        <template>
          <span>{{record.sale_price.user_name}}</span>
        </template>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
        </template>
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <!--<a-menu-item>-->
            <!--<a  >分销配置</a>-->
            <!--</a-menu-item>-->
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import setting from '@/config/setting'
import UserPicker from '@/components/UserPicker/'
import BasePicker from '@/components/BasePicker/'
import ShopPicker from '@/components/ShopPicker/'

  import areaOptions from '@/utils/area'
import qs from 'qs'
import moment from 'moment'

import {
  getOrderList,
  getGoodsOptions,
  setOrderStar,
  expressImport,
  setAllStar,
  getOrderDownloadUrl,
  getOrderDownloadUrl2
} from '@/api/order'
export default {
  name: 'OrderList',
  components: {
    AInput,
    ATextarea,
    STable,
    EditableCell,
    UserPicker,
    BasePicker,
    ShopPicker
  },
  data() {
    return {
      areaOptions,
      visible: false,
      saveLoading: false,
      formData: {
        title: '',
        rules: []
      },
      labelCol: {
        //          xs: { span: 24 },
        //          sm: { span: 5 },
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
        status: '',
        team_seller_id: undefined,
        seller_user_id: undefined,
        partner_id: undefined,
        sale_user_id:undefined,
        namekeys:undefined,
        base_id:undefined
      },
      shopFormData:{
        user_id:undefined
      },
      time_range_moment: [],
      goodsOptions: [],
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '商品',
          dataIndex: 'goods',
          scopedSlots: { customRender: 'goods' }
        },
        {
          width: '150px',
          title: '地址',
          dataIndex: 'buyer_name',
          scopedSlots: { customRender: 'buyer' }
        },
        {
          title: '价格',
          width: '250px',
          dataIndex: 'pay_price',
          scopedSlots: { customRender: 'price' }
        },
         {
          title: '打印次数',
          width: '100px',
          dataIndex: 'print_count', 
        },
        {
          title: '销售',
          width: '100px',
          dataIndex: 'sale_price', 
          scopedSlots: { customRender: 'sale_price' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData')
        console.log(this.queryParam)
        this.queryParam.cate_id = 0
        if (this.queryParam.cate_ids && this.queryParam.cate_ids.length) {
          this.queryParam.cate_id = [...this.queryParam.cate_ids].pop()
        }
        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }


        this.queryParam = Object.assign(this.queryParam, parameter)
        return getOrderList(this.queryParam).then(res => {
          console.log('res')
          return res.data
        })
      },
      setAllStarValue: 0,
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  computed: {},
  created() {},
  mounted() {
    let that = this
    console.log('query', this.$route.query)
    if (this.$route.query.status) {
      this.queryParam.status = this.$route.query.status + ''
    }
    that.getGoodsOptions()
  },
  methods: {
    moment,
    handleEdit(record) {
      if (record.type == 'shop') {
        const { href } = this.$router.resolve({ name: 'ShopOrderDetail', query: { id: record.id } })
        window.open(href, '_blank')
      } else {
        let { href } = this.$router.resolve({ name: 'OrderDetail', query: { id: record.id } })
        window.open(href, '_blank')
      }
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 查
    onSearch() {
      let self = this
      self.$refs.table.refresh(false)
    },
    setAllStatus(status) {
      let self = this
      setGoodsAllStatus({
        ids: self.selectedRowKeys,
        status: status
      }).then(res => {
        self.$message.success('设置成功')
        self.$refs.table.refresh(false)
      })
    },
    setStatus(goods_id, status) {
      setGoodsStatus({
        id: goods_id,
        status: status
      }).then(res => {
        self.$message.success('设置成功')
        self.$refs.table.refresh(false)
      })
    },
    starChange(record) {
      console.log(record)
      setOrderStar({
        id: record.id,
        star: record.star
      }).then(res => {})
    },
    // 删
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    sellerRewardDone() {
      this.sellerRewardVisible = false
    },
    dealtownRewardDone() {
      this.dealtownRewardVisible = false
    },
    getGoodsOptions() {
      let self = this
      getGoodsOptions()
        .then(res => {
          self.goodsOptions = res.data
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    download(type) {
      let that = this
      getOrderDownloadUrl(Object.assign(this.queryParam, { type: type }))
        .then(res => {
          console.log(res)
          window.open(res.data)
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })
    },
    download2(type) {
      let that = this
      getOrderDownloadUrl2(Object.assign(this.queryParam, { type: type }))
        .then(res => {
          console.log(res)
          window.open(res.data)
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })
    },
    download3(type){
      if(this.queryParam.time_range.length!=2){
          this.$message.error("请选择时间范围");
        return ;
      }
        window.open(setting.apiBaseURL+'/badminapi/order/provinceCityRewardsTable?type='+type+'&start_time='+this.queryParam.time_range[0]+'&end_time='+this.queryParam.time_range[1]);
    },
    download4(type){
      if(this.queryParam.time_range.length!=2){
          this.$message.error("请选择时间范围");
        return ;
      }
        window.open(setting.apiBaseURL+'/badminapi/order/partnerRewardsTable?type='+type+'&start_time='+this.queryParam.time_range[0]+'&end_time='+this.queryParam.time_range[1]);
    },
    setAllStar() {
      let self = this
      setAllStar({
        ids: self.selectedRowKeys,
        star: self.setAllStarValue
      })
        .then(res => {
          self.$message.success('设置成功')
          self.$refs.table.refresh(false)
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    beforeUpload(file) {
      let that = this
      let formdata = new FormData()
      console.log(file)
      formdata.append('upfile', file)
      formdata.append('action', 'test')
      console.log('formdata', formdata)
      expressImport(formdata)
        .then(res => {
          that.$message.success('上传成功')
          that.$refs.table.refresh(true)
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })
      return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    }
  },
  watch: {}
}
</script>
